import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reCorrectionFactor/create', params),
	update                : (params) => requests.post('/reCorrectionFactor/update', params),
	delete                : (params) => requests.getWithParams('/reCorrectionFactor/delete', params),
	restore               : (params) => requests.getWithParams('/reCorrectionFactor/restore', params),
	getPaged              : (params) => requests.getWithParams('/reCorrectionFactor/getPaged', params),
	getPagedAudit         : (params) => requests.getWithParams('/reCorrectionFactor/getPagedAudit', params),
	getPagedAll           : (params) => requests.getWithParams('/reCorrectionFactor/getPagedAll', params),
	getList               : (params) => requests.getWithParams('/reCorrectionFactor/getList', params)
}